import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const SocialEvent = (function() {
  function GetPastByMonitoredIndividual(monitoredIndividualId, pastNumberOfDays) {
    if (logComponent('SocialEvent')) { console.debug('SocialEvent GetPastByMonitoredIndividual'); }
    const params = { monitoredIndividualId, pastNumberOfDays };

    return axios.get('api/SocialEvent/GetPastEventsByMonitoredIndividual', getConfig( params));    
  }

  function GetNextByMonitoredIndividual(monitoredIndividualId) {
    if (logComponent('SocialEvent')) { console.debug('SocialEvent GetNextByMonitoredIndividual'); }
    const params = { monitoredIndividualId };

    return axios.get('api/SocialEvent/GetNextByMonitoredIndividual', getConfig( params));
  }

  function GetNextByFacility(facilityId) {
    if (logComponent('SocialEvent')) { console.debug('SocialEvent GetNextByFacility'); }
    const params = { facilityId };

    return axios.get('api/SocialEvent/GetNextByFacility', getConfig( params));
  }

  function GetAllForMonthByMonitoredIndividual(monitoredIndividualId, selectedTime) {
    if (logComponent('SocialEvent')) { console.debug('SocialEvent GetAllForMonthByMonitoredIndividual'); }
    const params = { monitoredIndividualId, selectedTime };

    return axios.get('api/SocialEvent/GetAllForMonthByMonitoredIndividual', getConfig( params));
  }  

  function GetAllForMonthByFacility(facilityId, selectedTime) {
    if (logComponent('SocialEvent')) { console.debug('SocialEvent GetAllForMonthByFacility'); }
    const params = { facilityId, selectedTime };

    return axios.get('api/SocialEvent/GetAllForMonthByFacility', getConfig( params));
  }


  return {
    GetPastByMonitoredIndividual,
    GetNextByMonitoredIndividual,
    GetNextByFacility,
    GetAllForMonthByMonitoredIndividual,
    GetAllForMonthByFacility
  }
})();

export default SocialEvent;